




















import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop({ default: 0 }) clubId!: number;

  dispatchType = "club/activity_bulletins";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "标题", dataIndex: "title" },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "截止时间", dataIndex: "endtime" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData({ club_id: this.clubId }, false);
  }
}
